import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'
import QuestionSlideCarousel from '../../uiKit/QuestionSlideCarousel'
import Icon from '../../misc/Icons'
import { formatDate } from '../../../utils/formatDate'

// Same budget as SearchPreviewQuestion — must stay inside the 408px inner
// width of the preview column to avoid forcing the flex column wider.
const PREVIEW_SLIDE_WIDTH = 380

function SearchPreviewSet({ hit, storeSet }) {
  // Local set carries the full embedded questions[] (with bodyHtml). When the
  // hit is Algolia-only we may still have a partial copy in state.sets; if
  // neither has questions, fall back to a count-only summary.
  const set = storeSet || hit
  const questionCount = Array.isArray(set && set.questions) ? set.questions.length : 0
  const editedAt = (set && set.clientModified) || (hit && hit.clientModified)
  const hasUsableQuestions = Array.isArray(set && set.questions) &&
    set.questions.length > 0 &&
    set.questions.some((q) => q && q.bodyHtml)

  return (
    <div className='searchPreviewPane-body searchPreviewSet'>
      <div className='searchPreviewPane-header'>
        <div className='searchPreviewPane-header-icon'>
          <Icon name='search-set' questionCount={questionCount} />
        </div>
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {set && set.name}
          </div>
          <div className='searchPreviewPane-header-meta'>
            <span>{`${questionCount} question${questionCount === 1 ? '' : 's'}`}</span>
          </div>
        </div>
      </div>
      <div className='searchPreviewSet-carousel'>
        {hasUsableQuestions ? (
          <QuestionSlideCarousel
            key={set.id}
            set={set}
            slideWidth={PREVIEW_SLIDE_WIDTH}
            preventPlay
            showSetNavigator
            hideTotalQuestionCount={false}
          />
        ) : (
          <div className='searchPreviewSet-empty'>
            <Icon name='search-set' questionCount={questionCount} />
            <span>
              {questionCount > 0 ? 'Preview unavailable — open the set to see its questions.' : 'This set has no questions yet.'}
            </span>
          </div>
        )}
      </div>
      <div className='searchPreviewPane-meta'>
        <span className='searchPreviewPane-meta-kind'>Set</span>
        {editedAt && (
          <span className='searchPreviewPane-meta-edited'>
            {'Edited '}
            {formatDate(editedAt)}
          </span>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  return {
    storeSet: id ? find(state.sets, { id }) : null,
  }
}

export default connect(mapStateToProps)(SearchPreviewSet)
